export const DOCUMENT_TYPES = [
   { value: "1", label: "Invoices" },
   { value: "2", label: "Invoice Statements" },
   { value: "3", label: "Credit Slips" },
   { value: "4", label: "Bank Statements" },
   { value: "5", label: "Credit Card Statements" },
];
